import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { NO_VALUE } from '../dash/dash.pipe';

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER',
}
@Pipe({
  name: 'gender',
  standalone: true,
})
export class GenderPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(gender: Gender): string {
    switch (gender) {
      case Gender.Male:
        return this.translateService.instant('GENDER.MALE');
      case Gender.Female:
        return this.translateService.instant('GENDER.FEMALE');
      case Gender.Other:
        return this.translateService.instant('GENDER.OTHER');
      default:
        return NO_VALUE;
    }
  }
}
